export function Logo() {
  return <img src="/images/logo-apollofy.svg" alt="Apollofy" />;
}
